export enum Headers {
  Authorization = 'Authorization',
  RetryHeader = 'X-Client-Retried',
}
